export default "__VITE_ASSET__DKWGjJPf__"